<template>
  <div class="bg-white borderd">
    <div class="px-10 py-2 mx-auto mt-0 mb-20">
      <div class="flex">
        <div>
          <h2 class="form-label mb-2">Tilldelade</h2>
          <select multiple class="w-64 h-64 overflow-auto form-multiselect" v-model="selectedAssigned">
            <option v-for="r in current.allowedClaims" :key="r" :value="r">
              {{r}}
            </option>
          </select>
        </div>

        <div class="flex flex-col mt-32 ml-5 mr-5">
          <button class="w-24 mb-2 btn_blue" @click="onAdd">
            lägg till
          </button>
          <button class="w-24 btn_blue" @click="onRemove">
            ta bort
          </button>
        </div>

        <div>
          <h2 class="form-label mb-2">Tillgängliga</h2>
          <select multiple class="w-64 h-64 overflow-auto form-multiselect" v-model="selectedUnassigned">
            <option v-for="r in unassignedClaims" :key="r" :value="r">
              {{r.type}}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { IdentityResourcesService } from "@/services/api-service";
import claimtypes from "@/services/claim-types";

export default {
  name: "identityclaims",
  data() {
    return {
      claims: [],
      selectedAssigned: [],
      selectedUnassigned: []
    };
  },

  computed: {
    ...mapGetters("identityresourcesStore", ["current"]),
    unassignedClaims() {
      return this.test(this.claims, 0);
    }
  },

  methods: {
    ...mapActions("identityresourcesStore", ["addClaims", "removeClaims"]),

    onAdd() {
      this.addClaims(this.selectedUnassigned);
    },
    onRemove() {
      this.removeClaims(this.selectedAssigned);
    },

    test(claim, type) {
      let anotherOne = this.current.allowedClaims;

      return claim.filter(
        array_el =>
          anotherOne.filter(anotherOne_el => anotherOne_el === array_el.type)
            .length === type
      );
    }
  },

  async mounted() {
    this.claims = claimtypes;
  }
};
</script>
